export const ANALYTICS_SEGMENT = 'segment';
export const ANALYTICS_SESSION_ID_STORAGE_KEY = 'analyticsSessionId';
export const ANALYTICS_ACTIONS = {
  DISPLAY: 'display',
  ACCESS: 'access',
  ABANDON: 'abandon',
  CREATE: 'create',
  STOP: 'stop',
  CONSENT: 'consent'
};
export const ANALYTICS_EVENTS = {
  WEBVIEW_DISPLAYED: 'webview_displayed',
  CONNECTION_MANAGED: 'connection_managed',
  DATA_SHARE_RESPONSE: 'data_share_response'
};
export const ANALYTICS_SOURCE_TYPES = {
  LIBRE_APP: 'libreApp',
  EXTERNAL_PARTNER: 'externalPartner'
};
export const ANALYTICS_MODULE_TYPES = {
  CONAPPS_MODULE: 'connectedApps'
};
export const CONNECTION_STATUS = {
  PENDING: 'pending',
  CONNECTED: 'connected'
};